var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isStatus ? '_box':''},[_c('FloatPlayer',{class:_vm.isStatus ? 'cpt-common-float-playerBox':'',attrs:{"type":"3","data":_vm.data},on:{"close":function($event){return _vm.$emit('close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }